import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import "./App.scss";
import ErrorBoundary from "./common/containers/error/ErrorBoundary";
import Login from "./pages/login/Login";
import Home from "./pages/home/Home";
import { history } from "./store";

interface AppProps {}

const App = (_: AppProps) => {
  useEffect(() => {
    console.log("window.location.search",window.location.search);
    
    const params = new URLSearchParams(window.location.search);
    console.log("params",params);
    
    const tokenParam = params.get("token");
    console.log("tokenParam",tokenParam);
    

    if (tokenParam) {
      try {
        const decoded = decodeURIComponent(tokenParam);
console.log("decoded",decoded);

        const parsed = JSON.parse(decoded);
console.log("parsed",parsed);
console.log("JSON.stringify(parsed)",JSON.stringify(parsed));


        localStorage.setItem("NAVIDOK_ACCESS_TOKEN", JSON.stringify(parsed));

        window.history.replaceState({}, document.title, window.location.pathname);

        window.location.reload();
      } catch (error) {
        console.error("Invalid token parameter:", error);
      }
    }
  }, []);

  return (
    <ErrorBoundary>
      <ConnectedRouter history={history}>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route path="/" component={Home} />
        </Switch>
      </ConnectedRouter>
    </ErrorBoundary>
  );
};

export default App;